import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {localization} from '../../Frames/localization';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {themeColorText} from '../../../src/App'
const useStyles = makeStyles({
    table: {
      minWidth: 100, 
    },
    rows: {
      padding: 12,
    }
    });
  
  function createData(name, valueMonth) {
    return {name, valueMonth };
  }
  
 
  
  export default function SimpleTable(props) {
    const classes = useStyles();
    var rows = []
    if(props.data.consumptionAmountCounter != null)
    {
      rows = [
        createData(localization.GetTranslate('Statistics.This month'), props.data.consumptionAmountCounter.currentMonth),
        createData(localization.GetTranslate('Statistics.Previous month'), props.data.consumptionAmountCounter.lastMonth),
      ];
    }else
    {
      rows = [
        createData(localization.GetTranslate('Statistics.This month'), 0),
        createData(localization.GetTranslate('Statistics.Previous month'), 0),
      ];
    }
    return (
        <div className={props.className}>
                <Table className={classes.table} aria-label="simple table">
                <TableBody>
                    {rows.map(row => (
                    <TableRow key={row.name} className={classes.rows}>
                        <TableCell className={classes.rows} component="th" scope="row">{row.name}</TableCell>
                        <TableCell className={classes.rows} style={{color: themeColorText.color ,fontWeight: 'bold'}} align="center">{row.valueMonth}&nbsp;грн</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
      </div>
    );
  }